import { Component, Input, OnChanges, OnInit, } from '@angular/core';

@Component({
  selector: 'app-config-arguments-card',
  templateUrl: './config-arguments-card.component.html',
  styleUrls: ['./config-arguments-card.component.scss']
})
export class ConfigArgumentsCardComponent implements OnInit, OnChanges {

  @Input() data: any;
  @Input() wfId: number | undefined;
  @Input() wfhId: number | undefined;
  triggerData = {};
  arguments = [];
  artifact: any;

  ngOnInit() {
    this.arguments = this.data?.arguments;
    this.data?.cng?.inputs_arguments;
    this.triggerData = {

      domain: this.data?.repoPtrn,
      repo: this.data?.repoUrl,
      trigger: "GitHub",
      option: this.data?.branchType,
      branch: this.data?.brName
    };
  }

  ngOnChanges(): void {
    this.arguments = this.data?.arguments;

    this.triggerData = {
      domain: this.data?.repoPtrn,
      repo: this.data?.repoUrl,
      trigger: "GitHub",
      option: this.data?.branchType,
      branch: this.data?.brName,
      artifact: this.artifact,
    };


  }

  readOnly = true;

  /**
   * Retrieves artifact data
   * @param data 
   */
  public getArtifact(data: any): void {
    this.artifact = data;
  }
}
